module.exports = __webpack_public_path__ + "img/DUCZ_BANNER.758312ec.png";